var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGas02 = function SvgGas02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "gas-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gas-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.116 13.518c-.022 1.01-.231 1.964-.642 2.815a5.683 5.683 0 0 1-1.522 1.926 5.673 5.673 0 0 1-2.684 1.209 2.77 2.77 0 0 0 .143-2.39c-.501-1.246-2.299-1.26-2.811-.018a2.788 2.788 0 0 0 .059 2.254 6.453 6.453 0 0 1-2.602-1.41 6.502 6.502 0 0 1-1.725-2.467s-.002-.003 0-.004a6.467 6.467 0 0 1-.447-2.369 6.46 6.46 0 0 1 2.658-5.228c.09-.05.18-.097.272-.142a5.444 5.444 0 0 0 .227 1.295 5.7 5.7 0 0 0 2.114 2.984 5.715 5.715 0 0 1-.23-3.773c.115-.404.274-.788.47-1.15a5.18 5.18 0 0 1 .511-.785 5.73 5.73 0 0 1 2.22-1.733v.006a5.685 5.685 0 0 0 1.563 3.926c.19.201.397.39.617.564 0 0 1.88 1.528 1.813 4.49h-.004Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gas-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgGas02 as ReactComponent };